module.exports = __webpack_public_path__ + "img/success-landing.37352385.png";